import React from 'react'
import PropTypes from 'prop-types'
import camelCase from 'lodash/camelCase'
import { useWatch } from 'react-hook-form'
import { Row, Col } from 'antd'

import EventBudget from 'components/ContactRequestFormComponents/EventBudget'
import EventCity from 'components/ContactRequestFormComponents/EventCity'
import EventDate from 'components/ContactRequestFormComponents/EventDate'
import EventGuests from 'components/ContactRequestFormComponents/EventGuests'
import EventRoom from 'components/ContactRequestFormComponents/EventRoom'
import EventType from 'components/ContactRequestFormComponents/EventType'
import { DEFAULT_START_TIME, DEFAULT_END_TIME } from 'components/ContactRequestFormComponents/constants'

import EventTimes from 'components/EventTimes'

import MeetingpackageAvailabilityChecker from './MeetingpackageAvailabilityChecker'

import './index.less'

const EventDetails = (props) => {
  const {
    guestCountColSpan,
    initialData,
    provider,
    provider: {
      eventCategories,
      room,
      type,
      isMeetingpackageProvider,
      cities,
    },
  } = props

  const isEventLocation = type === 'EventLocation'
  const isEventRoom = type === 'EventRoom'
  const showRoomLayoutSelect = isEventLocation || isEventRoom
  const selectedEventCategoryInFilters = eventCategories.find(category => category.name === initialData.eventCategory)
  const previouslySelectedEventCategory = eventCategories.find(category => category.id === initialData.eventCategoryId)
  const initialEventCategoryId = (previouslySelectedEventCategory || selectedEventCategoryInFilters)?.id
  const selectedEventCategoryId = useWatch({ name: 'eventCategoryId', defaultValue: initialEventCategoryId })
  const isB2C = (eventCategories.find(category => category.id === selectedEventCategoryId) || {}).isB2c
  const selectedRoomLayout = useWatch({ name: 'roomType', defaultValue: initialData.roomType })
  const eventGuestsCapacity = room?.[camelCase(selectedRoomLayout)]
  const isEventSupplierRelated = [type, provider.parent?.type].includes('EventSupplier')

  const initialEventGuestsCount = initialData.numberOfPersons > eventGuestsCapacity
    ? eventGuestsCapacity
    : initialData.numberOfPersons

  return (
    <div className="contact-request__event-details">
      <Row>
        <Col>
          <EventType
            eventCategories={eventCategories}
            initialValue={initialEventCategoryId}
            forceFirstEventCategory={isEventRoom}
          />
        </Col>
      </Row>

      {!isMeetingpackageProvider && (
        <Row>
          <Col>
            <EventDate
              multiple={!isEventRoom}
              initialValue={initialData.requestedDates}
              onCalendarOpen={() => {}}
              scrollWhenOpen={false}
            />
          </Col>
        </Row>
      )}

      {isEventRoom && !isMeetingpackageProvider && (
        <Row>
          <Col>
            <EventTimes
              rowProps={{ gutter: 24 }}
              labelPostfix="*"
              initialStartTime={initialData.timesStartsAt || DEFAULT_START_TIME}
              initialEndTime={initialData.timesEndsAt || DEFAULT_END_TIME}
              />
          </Col>
        </Row>
      )}

      <Row gutter={24}>
        <Col span={showRoomLayoutSelect ? guestCountColSpan : 24}>
          <EventGuests
            initialValue={initialEventGuestsCount}
            showError={!showRoomLayoutSelect}
            room={room}
          />
        </Col>

        {showRoomLayoutSelect && (
          <Col span={24 - guestCountColSpan}>
            <EventRoom initialValue={initialData.roomType} room={room} />
          </Col>
        )}
      </Row>

      {isB2C && (
        <Row>
          <Col>
            <EventBudget />
          </Col>
        </Row>
      )}

      {isMeetingpackageProvider && (
        <MeetingpackageAvailabilityChecker
          initialData={initialData}
          provider={provider}
        />
      )}

      {isEventSupplierRelated && (
        <Row>
          <Col>
            <EventCity cities={cities} />
          </Col>
        </Row>
      )}
    </div>
  )
}

EventDetails.defaultProps = {
  guestCountColSpan: 12,
}

EventDetails.propTypes = {
  guestCountColSpan: PropTypes.number.isRequired,
  initialData: PropTypes.shape({
    eventCategoryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    eventCategory: PropTypes.string,
    numberOfPersons: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    requestedDates: PropTypes.array,
    roomType: PropTypes.string,
    timesStartsAt: PropTypes.string,
    timesEndsAt: PropTypes.string,
  }).isRequired,
  provider: PropTypes.shape({
    isMeetingpackageProvider: PropTypes.bool,
    room: PropTypes.object,
    type: PropTypes.string.isRequired,
    eventCategories: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        name: PropTypes.string.isRequired,
        isB2c: PropTypes.bool,
      }),
    ).isRequired,
    parent: PropTypes.shape({
      type: PropTypes.string,
    }),
    cities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        displayName: PropTypes.string,
      }),
    ),
  }),
}

export default EventDetails
